import { render, staticRenderFns } from "./document.vue?vue&type=template&id=6164986a"
import script from "./document.vue?vue&type=script&lang=ts"
export * from "./document.vue?vue&type=script&lang=ts"
import style0 from "./document.vue?vue&type=style&index=0&id=6164986a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports